import { render, staticRenderFns } from "./uploadSampleFile.vue?vue&type=template&id=63748cb6&scoped=true&"
import script from "./uploadSampleFile.vue?vue&type=script&lang=js&"
export * from "./uploadSampleFile.vue?vue&type=script&lang=js&"
import style0 from "./uploadSampleFile.vue?vue&type=style&index=0&id=63748cb6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63748cb6",
  null
  
)

export default component.exports